import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import FormButton from "../../components/form/FormButton";
import FormDropdown from "../../components/form/FormDropdown";
import ModalBody from "../../components/modal/ModalBody";
import ModalDescription from "../../components/modal/ModalDescription";
import ModalField from "../../components/modal/ModalField";
import ModalFooter from "../../components/modal/ModalFooter";
import ModalFooterRightGroup from "../../components/modal/ModalFooterRightGroup";
import ModalGroup from "../../components/modal/ModalGroup";
import ModalHeading from "../../components/modal/ModalHeading";
import ModalRow from "../../components/modal/ModalRow";
import ModalView from "../../components/modal/ModalView";
import strictNarrativeCorrectiveOptions from "../../constants/strictNarrativeCorrectiveOptions";

const options = [
  {
    label: "Convert parent documents to folders",
    value: strictNarrativeCorrectiveOptions.CHANGE_TYPE
  },
  {
    label: "Move children to nearest valid parent",
    value: strictNarrativeCorrectiveOptions.FLATTEN
  }
];

class SettingsStrictNarrativeActionModal extends PureComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      option: strictNarrativeCorrectiveOptions.CHANGE_TYPE
    };

    this.onDoneClick = this.onDoneClick.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onDoneClick() {
    this.props.onDoneClick(this.state.option);
  }

  onCloseClick() {
    this.props.onCloseClick();
  }

  onChange(option) {
    this.setState({
      option
    });
  }

  render() {
    const labelText = "How should we handle children nested inside documents?";
    let header = null;
    let footer = null;
    let groupLabel = null;

    //#!if iOS === true
// header = <ModalHeading title="Strict Narrative Confirmation" showBack={true} onBackClick={this.onDoneClick} />;
// groupLabel = labelText;
    //#!else
    header = <ModalHeading title={labelText} showCancel={false} />;
    footer = (
      <ModalFooter>
        <ModalFooterRightGroup>
          <FormButton primary={false} label="Cancel" onClick={this.onCloseClick} />
          <FormButton primary={true} label="OK" onClick={this.onDoneClick} />
        </ModalFooterRightGroup>
      </ModalFooter>
    );
    // #!endif

    return (
      <ModalView className="confirmation" header={header} footer={footer}>
        <ModalBody>
          <ModalGroup label={groupLabel}>
            {this.props.explanation ? (
              <ModalRow>
                <ModalDescription>
                  <span>{this.props.explanation}</span>
                </ModalDescription>
              </ModalRow>
            ) : null}
            <ModalRow>
              <ModalField>
                <FormDropdown options={options} value={this.state.option} onChange={this.onChange} />
              </ModalField>
            </ModalRow>
          </ModalGroup>
        </ModalBody>
      </ModalView>
    );
  }
}

SettingsStrictNarrativeActionModal.propTypes = {
  explanation: PropTypes.string,
  onDoneClick: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired
};

export default SettingsStrictNarrativeActionModal;
